import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const removeFromBasket = createAsyncThunk("basket/removeFromBasket", async (payload, thunkAPI) => {
  try {
    const response = await API("/basket/remove-from-cart", {
      method: "POST",
      body: payload,
    });

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const checkVoucher = createAsyncThunk("basket/checkVoucher", async (payload, thunkAPI) => {
  try {
    const response = await API("/check-voucher", {
      method: "POST",
      body: payload,
    });

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const addToBasket = createAsyncThunk("basket/addToBasket", async (payload, thunkAPI) => {
  try {
    const response = await API("/basket/add-to-cart", {
      method: "POST",
      body: payload,
    });

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const loadBasket = createAsyncThunk(
  "basket/loadBasket",
  async ({orderCookieId = "", overrideOrderId = 0, partnerId = 0, partnerCheckoutOverride = 0}, thunkAPI) => {
    try {
      const response = await API(
        `/basket/get-cart/${orderCookieId}/${overrideOrderId}/${partnerId}/${partnerCheckoutOverride}`,
      );

      return thunkAPI.fulfillWithValue(response);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updatePaymentIntent = createAsyncThunk("basket/updatePaymentIntent", async (payload, thunkAPI) => {
  try {
    const response = await API("checkout/payment-intent", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});
